import * as ResultsUtils from '../utils/results';
import HighPass from '../filter/high-pass';

function _getOpAmpNonIdealities(stageFp, gain, timeAxis) {
  // var filter = HighPass.create();
  var stepResponseSetup = HighPass.setupFirstOrderStepResponse(stageFp, gain);

  var opAmpNonIdealities = [];
  for (var t = 0; t < timeAxis.length; t++) {
    var val = ResultsUtils.computeFirstOrderStepResponseIdeal(timeAxis[t], stepResponseSetup);
    opAmpNonIdealities.push(val);
  }

  return opAmpNonIdealities;
}

function _getStageFp(circuit, k) {
  var rescombo = _computeResCombo(circuit);
  var gainTerm = _computeGainTerm(circuit, k);
  var result = 1 / (gainTerm * rescombo);
  return result;
}

function _getGain(circuit) {
  var rescombo = _computeResCombo(circuit);
  var result = 1 / rescombo;
  return result;
}

function _computeResCombo(circuit) {
  var r1 = circuit.r1.value;
  var r2 = circuit.r2.value;
  var result = r1 / r2 + r1 / circuit.opAmp.rOut + 1;
  return result;
}

function _computeGainTerm(circuit, kValue) {
  var r1 = circuit.r1.value;
  var result = (kValue * circuit.opAmp.rOut) / (r1 * circuit.opAmp.gbw);
  return result;
}

export function getActualStepResponse(idealStep, circuit, timeAxis, k) {
  var stageFp = _getStageFp(circuit, k);
  var gain = _getGain(circuit);
  var opAmpNonIdealities = _getOpAmpNonIdealities(stageFp, gain, timeAxis);
  var result = idealStep.map((item, index) => {
    return item + opAmpNonIdealities[index];
  });

  return result;
}
